{
  "docs.fallback.api_title": "API של Tov+",
  "docs.fallback.api_version": "v1",
  "docs.fallback.documentation_entry": "פריט תיעוד.",
  "docs.fallback.operation": "פעולה",
  "docs.fallback.webhook_event": "אירוע Webhook",
  "docs.faq.guest_accounts_answer": "לא. גישת אורחים היא קודם כול באמצעות טוקן, וחשבון הוא אופציונלי. זרימות אורחים בסיסיות צריכות לעבוד בלי לחייב יצירת חשבון.",
  "docs.faq.guest_accounts_question": "האם אורחים צריכים ליצור חשבון?",
  "docs.faq.internal_docs_answer": "הגדרות פנימיות, סביבה מקומית, runbooks תפעוליים, APIs למנהלים והפניות swagger פנימיות מלאות שייכים עכשיו לאתר הניהול ולא לאתר התיעוד הציבורי.",
  "docs.faq.internal_docs_question": "לאן עברו מסמכי ההקמה והניהול הפנימיים?",
  "docs.faq.modules_answer": "כן. מודולים מוגדרים ברמת ה-Occasion ומופעלים לכל אירוע, כך ש-occasion יכול להשתמש ב-RSVP בכל מקום ולהגביל seating או gallery לאירועים מסוימים.",
  "docs.faq.modules_question": "האם ניתן להפעיל מודולים באופן סלקטיבי?",
  "docs.faq.occasion_answer": "Occasion הוא אובייקט התכנון הראשי. הוא מאגד טקס, קבלת פנים, נסיעות, בראנץ׳, ספקים, אורחים, נכסים והרשאות למרחב תפעולי מתואם אחד.",
  "docs.faq.occasion_question": "מהו Occasion ב-Tov+?",
  "docs.faq.public_docs_answer": "רק חומר שמיועד לאינטגרציות: נקודות קצה ציבוריות של API, אירועי webhook, ציפיות auth ומושגי מערכת שבונים חיצוניים צריכים כדי להתחבר ל-Tov+.",
  "docs.faq.public_docs_question": "מה שייך לתיעוד המפתחים הציבורי?",
  "docs.faq.scoping_answer": "שניהם עוברים דרך מודל Actor, אבל כל actor מקבל תצוגות מורשות לפי תפקיד, scope וגישה למשאבים. ספקים רואים פרוסות תפעוליות, ואורחים רואים פרטים רלוונטיים להזמנה.",
  "docs.faq.scoping_question": "איך ספקים ואורחים מקבלים scope שונה?",
  "docs.navigation.development": "פיתוח",
  "docs.navigation.faq": "שאלות נפוצות",
  "docs.navigation.features": "יכולות",
  "docs.navigation.how_it_works": "איך זה עובד",
  "docs.navigation.overview": "סקירה",
  "docs.navigation.planner_dashboard": "דשבורד מתכננים",
  "docs.navigation.planner_sign_in": "כניסת מתכננים",
  "docs.navigation.primary": "ראשי",
  "docs.navigation.product_links": "קישורי מוצר",
  "docs.navigation.public_site": "אתר ציבורי",
  "docs.navigation.sections": "מקטעים",
  "docs.pages.categories_label": "קטגוריות תיעוד",
  "docs.pages.development_description": "הנחיות אינטגרציה ציבוריות עבור APIs, webhooks ודפוסי חיבור חיצוניים של Tov+.",
  "docs.pages.event_label": "אירוע",
  "docs.pages.faq_description": "שאלות נפוצות על פלטפורמת Tov+, גישת אורחים, מודולים ותיעוד ציבורי למפתחים.",
  "docs.pages.guides_description": "עיינו במדריכים ציבוריים נבחרים להבנת Tov+ ולבניית אינטגרציות.",
  "docs.pages.guides_heading": "תיעוד",
  "docs.pages.guides_title": "מדריכים",
  "docs.pages.min_read": "דקות קריאה",
  "docs.pages.overview_title": "סקירת תיעוד",
  "docs.pages.public_api_description": "רפרנס HTTP ציבורי מבוסס OpenAPI שנגזר מ-resources/swagger/public-openapi.yaml.",
  "docs.pages.public_api_summary": "רפרנס HTTP ציבורי מבוסס OpenAPI שנגזר מחוזה Tov+ החיצוני והנבחר.",
  "docs.pages.public_api_title": "רפרנס API ציבורי",
  "docs.pages.toc_label": "תוכן עניינים",
  "docs.pages.toc_title": "בעמוד זה",
  "docs.pages.webhook_description": "רפרנס אירועי webhook שנגזר מ-resources/swagger/webhooks.yaml.",
  "docs.pages.webhook_summary": "רפרנס אירועי webhook ציבוריים לבונים חיצוניים שמתחברים לפלטפורמת Tov+.",
  "docs.pages.webhook_title": "רפרנס Webhooks",
  "docs.pages.webhooks_heading": "אירועי webhook ציבוריים",
  "docs.pages.webhooks_intro": "הרפרנס הזה מגיע מ-resources/swagger/webhooks.yaml ומיועד לבונים חיצוניים שצריכים את קטלוג האירועים בלי שאר התיעוד הפנימי של הפלטפורמה.",
  "docs.sections.development_description": "רפרנסים מכווני אינטגרציה עבור APIs ציבוריים, webhooks, אבטחה ודפוסי חיבור.",
  "docs.sections.faq_description": "שאלות נפוצות על המודל מבוסס ה-occasion, גישת אורחים, מודולים ותיעוד ציבורי.",
  "docs.sections.features_description": "מדריכי מוצר ציבוריים ליכולות מתכננים, אורחים, publishing, תקשורת ומודולים.",
  "docs.sections.how_it_works_description": "מושגי ליבה של הפלטפורמה, דפוסי גישה והמודל מבוסס ה-occasion שמאחורי Tov+.",
  "docs.site.description": "תיעוד ציבורי למוצר, יכולות, API ו-webhooks עבור פלטפורמת Tov+ מבוססת occasion.",
  "docs.site.tagline": "תיעוד ציבורי למוצר, יכולות ואינטגרציות",
  "docs.site.title": "מסמכי Tov+"
}
